import { jsx } from "react/jsx-runtime";
import { classes } from "./form-styles.st.css";
const FormStyles = ({ children, enabled }) => {
  if (!enabled) {
    return /* @__PURE__ */ jsx("div", { children });
  }
  return /* @__PURE__ */ jsx("div", { className: classes.formStyles, children });
};
export {
  FormStyles
};
//# sourceMappingURL=form-styles.js.map
